import { gql } from "@apollo/client";

export const CREATE_SUBSCRIPTION_WELLNESSPLAN = gql`
mutation createSubscriptionWellnessPlanV2($data: SubscriptionInputV2!){
    createSubscriptionWellnessPlanV2(subscriptionInput: $data){
      success
      messages
      paymentStatus
      planId
      subscriptionId
      failedInvoiceLink
    }
  }
`;
